<dc-navbar-default></dc-navbar-default>
<main class="position-relative overflow-hidden">
  <router-outlet></router-outlet>
</main>
